import React from 'react';

const Bar = () => <div>Bar</div>;

export default Bar;
